import { render } from "./Accepted.vue?vue&type=template&id=072b5de0"
import script from "./Accepted.vue?vue&type=script&lang=js"
export * from "./Accepted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__